export enum Step {
  HINT = 0,
  REASON,
  CHECK_LIST,
  AUTHORIZATION,
  SUCCESS,
}
